<template>
  <v-app>
    <v-app-bar
      app
      dense
      color="blue darken-3"
      dark
      elevation="4"
    >
      <div class="d-flex align-center">
      <v-btn text href="/"><span class="mr-2">Gamsat Simulator</span></v-btn>
      </div>

      <v-spacer></v-spacer>
      
      <!-- <v-btn icon>
        <v-icon>
          mdi-book-open-variant
        </v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon color="green accent-3">
          mdi-pen
        </v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>
          mdi-flask
        </v-icon>
      </v-btn> -->
    </v-app-bar>

    <v-main>
      <HelloWorld/>
    </v-main>
  </v-app>
</template>

<script>
import HelloWorld from './components/HelloWorld';

// previous v-bar colour: "#A31D58"

export default {
  name: 'App',
  created () {
            document.title = "Gamsat Simulator";
        },

  components: {
    HelloWorld,
  },

  data: () => ({
    
  }),
};
</script>
